import EdenredButtons from '@pages/DesignSystem/button/EdenredButton';
import ETypo from '@pages/DesignSystem/Typo';
import { focus_state_icons } from 'src/assets/icons/focus_state';
import ImageComponent from '@sharedComponent/image-component';
import React from 'react';
import setupAction from 'src/components/shared/app-action-reducer/action';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ClevertapReact from 'src/utils/clever-tap';
import '../../../NewHrModuleSetup/DocumentsExpiry/documentSetup.scss';

const list = [
	{
		iconSrc: focus_state_icons.deliveredSuccess,
		text: 'Manage basic salary, overtime, addition and deductions',
	},
	{
		iconSrc: focus_state_icons.deliveredSuccess,
		text: 'Automated payroll calculations',
	},
	{
		iconSrc: focus_state_icons.deliveredSuccess,
		text: 'Your employees will get instantly payslips',
	},
	{
		iconSrc: focus_state_icons.deliveredSuccess,
		text: 'Download department-wise salary reports',
	},
];
const UploadSpreadsheetSetup = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const handleGetStarted = () => {
		ClevertapReact.event('V1_1_Payroll_Spreadsheet_GetStarted');
		dispatch(setupAction.creators.postHrSetupStatus({ hrOnBoardingFlowCompleted: true }));
		history.push({ pathname: '/hr-features/allowance', state: { editUploadSpreadsheet: true } });
	};
	return (
		<div className="wrappers">
			<span className="titles-container">
				<ETypo h2>Upload Spreadsheet</ETypo>

				<span>
					<EdenredButtons
						children="Get started!"
						onClick={typeof handleGetStarted === 'function' && handleGetStarted}
						btnType="primary"
						rightIcon={<ImageComponent className="rightIcon" src={focus_state_icons.RightArrow} />}
					/>
				</span>
			</span>
			<div className="content-wrapper">
				<div className="hero-content">
					<div className="hero">
						<ImageComponent src={focus_state_icons?.StarIcon} className="icon-wrapper" />
						<ETypo h2>Your payroll experience has been upgraded!</ETypo>
					</div>

					<section className="list-container">
						<ETypo h3>What is new?</ETypo>
						{list.map((item) => (
							<div className="list">
								<ImageComponent src={item?.iconSrc} />
								<ETypo h5>{item?.text}</ETypo>
							</div>
						))}
					</section>
				</div>
				<div className="video-wrapper">
					<video className="video-container-setup" autoPlay="true" controls>
						<source src="https://cdn.edenred.ae/money-transfer-videos/HR/hrvideo1(aad).mp4" type="video/mp4" />
					</video>
				</div>
			</div>
		</div>
	);
};

export default UploadSpreadsheetSetup;
